export const digitalBadgeData = {
  text: 'Discover why the 2022 Atlas Cross Sport is \nrecommended by',
  boldText: 'Consumer Reports.',
  trustmarkNumber: 'JKZCOJMZ',
  element: 'badgeAtlasCrossSport2022',
  badgeImageWidth: 600,
};
